export const taxProfile = {
  taxProfileNavTitle: 'Fiscal data',
  taxProfileRowAction: 'Add or edit fiscal data',
  taxProfileOrganizationTitle: 'Business fiscal data',
  taxProfileOrganizationSubtitle:
    'This is how your business appears as the issuer on every electronic invoice.',
  taxProfileContactTitle: 'Fiscal data',
  taxProfileContactSubtitle:
    'Needed to issue a tax credit invoice (Crédito Fiscal) to this customer.',
  taxProfileContactCreateHint:
    'After saving the contact you can add its fiscal data from Edit.',
  taxProfileNotAvailable:
    'Fiscal data is only available for organizations in El Salvador.',
  taxProfileIdentitySection: 'Identification',
  taxProfileNamesSection: 'Name and activity',
  taxProfileAddressSection: 'Address',
  taxProfileTaxpayerType: 'Taxpayer type',
  taxProfileDui: 'DUI',
  taxProfileNit: 'NIT',
  taxProfileNrc: 'NRC',
  taxProfileNitOrDui: 'DUI or NIT',
  taxProfileIdentityHelp:
    'Either one is enough: DUI or NIT. You can type them with hyphens; only the digits are saved, as the tax authority requires.',
  taxProfileOtherDocumentType: 'Other document (foreigners)',
  taxProfileOtherDocumentNumber: 'Document number',
  taxProfileLegalName: 'Legal name',
  taxProfileTradeName: 'Trade name',
  taxProfileEconomicActivity: 'Economic activity',
  taxProfileEconomicActivitySearch: 'Search by code or description',
  taxProfileDepartment: 'Department',
  taxProfileMunicipality: 'Municipality',
  taxProfileDistrict: 'District',
  taxProfileAddress: 'Address (neighborhood, street and number)',
  taxProfilePhone: 'Phone',
  taxProfileEmail: 'Invoice email',
  taxProfileSelect: 'Select an option',
  taxProfileReadyOrganization:
    'Your business has all the fiscal data needed to issue electronic invoices.',
  taxProfileReadyContact:
    'Ready for tax credit invoices: this customer has all the data needed.',
  taxProfileIncompleteOrganization:
    'Some data is missing to issue electronic invoices',
  taxProfileIncompleteContact:
    'Some data is missing to issue a tax credit invoice',
  taxProfileMissingFields: 'Complete:',
  taxProfileInvalidDui: 'The DUI must have 9 digits',
  taxProfileInvalidNit: 'The NIT must have 14 digits',
  taxProfileInvalidNrc: 'The NRC must have between 2 and 8 digits',
  taxProfileInvalidDocumentNumber: 'Must have between 6 and 20 letters or digits',
  taxProfileInvalidPhone:
    'The phone must have at least 8 digits and only digits, spaces, hyphens or parentheses',
  taxProfileInvalidEmail:
    'The email must have an @ and a domain with an extension, for example invoices@business.com',
  taxProfileSave: 'Save fiscal data',
  taxProfileSaved: 'Fiscal data saved',
  taxProfileSaveError: 'The fiscal data could not be saved',
  taxProfileLoadError: 'The fiscal data could not be loaded. Try again.',
};
